// extracted by mini-css-extract-plugin
export var actions = "_se-4";
export var item = "_se-1";
export var price = "_se-3";
export var quantity = "_se-2";
export var table = "_se-0";